<template>
  <b-modal ref="modal" hide-footer title="Rearrange Callback">
    <validation-observer ref="observer" v-slot="{ handleSubmit }">
      <b-form @submit.stop.prevent="handleSubmit(onSubmit)">
        <b-row class="my-1">
          <b-col md="4">
            <label for="callbackDate1">Rearrange Date</label>
          </b-col>
          <b-col md="8">
            <validation-provider
              name="Rearrange Date"
              :rules="{ required: true }"
              v-slot="validationContext"
            >
              <b-form-datepicker
                id="callbackDate1"
                v-model="form.date"
                :state="getValidationState(validationContext)"
                :date-format-options="{
                  year: 'numeric',
                  month: 'numeric',
                  day: 'numeric',
                }"
                locale="en-GB"
              ></b-form-datepicker>
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </validation-provider>
          </b-col>
        </b-row>

        <b-row class="my-1">
          <b-col md="4">
            <label for="notes">Time</label>
          </b-col>
          <b-col md="8">
            <validation-provider
              name="Time"
              :rules="{ required: true }"
              v-slot="validationContext"
            >
              <b-form-select
                id="notes"
                v-model="form.time"
                :options="callbackTime"
                :state="getValidationState(validationContext)"
              ></b-form-select>
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </validation-provider>
          </b-col>
        </b-row>

        <b-row class="my-1">
          <b-col md="4">
            <label for="notes">Callback Priority</label>
          </b-col>
          <b-col md="8">
            <validation-provider
              name="Callback Priority"
              :rules="{ required: true }"
              v-slot="validationContext"
            >
              <b-form-select
                id="notes"
                v-model="form.priorityId"
                :options="priorities"
                :state="getValidationState(validationContext)"
              ></b-form-select>
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </validation-provider>
          </b-col>
        </b-row>

        <b-row class="my-1">
          <b-col md="4">
          </b-col>
          <b-col md="8">
            <b-button type="submit" variant="success" class="margin-right">
              <font-awesome-icon icon="save" /> Save
            </b-button>
            <b-button type="reset" variant="danger" @click="cancel">
              <font-awesome-icon icon="times" /> Cancel Changes
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
  </b-modal>
</template>

<script>

import CompanyService from '@/services/Company.service';

export default {
  props: {
    companyId: Number
  },
  data() {
    return {
      noteTypes: [],
      time: null,
      form: {
        companyId: null,
        date: null,
        time: null,
        priorityId: null
      },
      priorities: [
        { value: null, text: "Select Priority", disabled: true },
        { value: "10", text: "Low" },
        { value: "20", text: "Medium" },
        { value: "30", text: "High" },
      ],
      callbackTime: [
        { value: null, text: "Select Time", disabled: true },
        { value: "08:00", text: "8:00 AM" },
        { value: "08:15", text: "8:15 AM" },
        { value: "08:30", text: "8:30 AM" },
        { value: "08:45", text: "8:45 AM" },
        { value: "09:00", text: "9:00 AM" },
        { value: "09:15", text: "9:15 AM" },
        { value: "09:30", text: "9:30 AM" },
        { value: "09:45", text: "9:45 AM" },
        { value: "10:00", text: "10:00 AM" },
        { value: "10:15", text: "10:15 AM" },
        { value: "10:30", text: "10:30 AM" },
        { value: "10:45", text: "10:45 AM" },
        { value: "11:00", text: "11:00 AM" },
        { value: "11:15", text: "11:15 AM" },
        { value: "11:30", text: "11:30 AM" },
        { value: "11:45", text: "11:45 AM" },
        { value: "12:00", text: "12:00 PM" },
        { value: "12:15", text: "12:15 PM" },
        { value: "12:30", text: "12:30 PM" },
        { value: "12:45", text: "12:45 PM" },
        { value: "13:00", text: "1:00 PM" },
        { value: "13:15", text: "1:15 PM" },
        { value: "13:30", text: "1:30 PM" },
        { value: "13:45", text: "1:45 PM" },
        { value: "14:00", text: "2:00 PM" },
        { value: "14:15", text: "2:15 PM" },
        { value: "14:30", text: "2:30 PM" },
        { value: "14:45", text: "2:45 PM" },
        { value: "15:00", text: "3:00 PM" },
        { value: "15:15", text: "3:15 PM" },
        { value: "15:30", text: "3:30 PM" },
        { value: "15:45", text: "3:45 PM" },
        { value: "16:00", text: "4:00 PM" },
        { value: "16:15", text: "4:15 PM" },
        { value: "16:30", text: "4:30 PM" },
        { value: "16:45", text: "4:45 PM" },
        { value: "17:00", text: "5:00 PM" },
        { value: "17:15", text: "5:15 PM" },
        { value: "17:30", text: "5:30 PM" },
        { value: "17:45", text: "5:45 PM" },
        { value: "18:00", text: "6:00 PM" },
        { value: "18:15", text: "6:15 PM" },
        { value: "18:30", text: "6:30 PM" },
        { value: "18:45", text: "6:45 PM" },
        { value: "19:00", text: "7:00 PM" },
        { value: "19:15", text: "7:15 PM" },
        { value: "19:30", text: "7:30 PM" },
        { value: "19:45", text: "7:45 PM" },
        { value: "20:00", text: "8:00 PM" },
        { value: "20:15", text: "8:15 PM" },
        { value: "20:30", text: "8:30 PM" },
        { value: "20:45", text: "8:45 PM" },
        { value: "21:00", text: "9:00 PM" },
      ],
    };
  },
  mounted() {
    /*const allowedNoteTypes = [10, 20, 30, 40, 999]; // From Globe
    this.$http.get('lookups/companynotetypes').then((response) => {
      response.data.forEach(n => {
        if (allowedNoteTypes.includes(n.id)) {
          this.noteTypes.push({ text: n.name, value: n.id  });
        }
      });
    });    */
  },
  methods: {
    showModal() {
      this.$refs["modal"].show();
    },
    hideModal() {
      this.$refs["modal"].hide();
    },
    cancel() {
      this.clear();
      this.$refs["modal"].hide();
    },
    onSubmit() {
      this.form.companyId = this.companyId;
      CompanyService.saveRearrangeCallback(this.form).then(() => {
        this.clear();
        this.$parent.loadCallbacks();
        this.hideModal();
      });
    },
    clear() {
      this.form.companyId = null;
      this.form.date = null;
      this.form.time = null;
      this.form.priorityId = null;
      this.form.notes = "";
    },
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
  }
};
</script>

<style scoped>
</style>
